<template>
  <div class="top">
    <div class="top-button is-left">
      <div class="tags-breadcrumb">
        <i class="icon-navicon tag-collapse" :class="[{ 'tag-collapse_right': isCollapse }]" @click="showCollapse"></i>
      </div>
    </div>
    <h1 class="top-title">
      <topMenu></topMenu>
    </h1>
    <h1 class="top-title">{{userInfo.companyName}}</h1>
    <div class="top-button is-right">
      <el-tooltip class="item" effect="dark" content="打印助手V2.0" placement="bottom">
        <span class="top-item">
          <a href="../static/PrinterHelper.zip" style="font-size: 13px">打印助手</a>
        </span>
      </el-tooltip>
      <el-tooltip class="item" effect="dark" content="主题色" placement="bottom">
        <span class="top-item">
          <top-theme></top-theme>
        </span>
      </el-tooltip>
      <el-tooltip class="item" effect="dark" content="锁屏" placement="bottom">
        <span class="top-item">
          <top-lock></top-lock>
        </span>
      </el-tooltip>
      <el-tooltip class="item" effect="dark" :content="isFullScren?'退出全屏':'全屏'" placement="bottom">
        <span class="top-item">
          <i :class="isFullScren?'icon-tuichuquanping':'icon-quanping'" @click="handleScreen"></i>
        </span>
      </el-tooltip>
      <el-tooltip class="item" effect="dark" content="用户头像" placement="bottom">
        <img class="top-userImg" :src="userInfo.avatar">
      </el-tooltip>
      <el-dropdown>
        <span class="el-dropdown-link">
          {{userInfo.userName}}
          <i class="el-icon-arrow-down el-icon--right"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item>
            <router-link to="/">首页</router-link>
          </el-dropdown-item>
          <el-dropdown-item @click.native="toPersonal">个人中心</el-dropdown-item>
          <el-dropdown-item @click.native="showVerDetail">{{sysVer}}</el-dropdown-item>
          <el-dropdown-item @click.native="downUm">帮助</el-dropdown-item>
          <el-dropdown-item @click.native="logout" divided>退出系统</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>

    <el-dialog title="版本更新详情" :visible.sync="verDetailVisible" :modal-append-to-body="false">
      <el-table :data="tableData" highlight-current-row border style="text-align:left" :span-method="objectSpanMethod">
        <el-table-column label="版本" prop="version" width="100">
        </el-table-column>
        <el-table-column label="日期" prop="updateTime" width="180">
          <template slot-scope="scope">
            {{new Date(scope.row.updateTime).toLocaleDateString()}}
          </template>
        </el-table-column>
        <el-table-column label="类型" prop="updateType" width="100">
        </el-table-column>
        <el-table-column label="模块" prop="menu" width="100">
        </el-table-column>
        <el-table-column label="内容" prop="log">
        </el-table-column>
        <el-table-column label="开发者" prop="userName" width="100">
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>
<script>
  import {mapState, mapGetters} from "vuex";
  import {fullscreenToggel, listenfullscreen} from "@/util/util";
  import topLock from "./top-lock";
  import topMenu from "./top-menu";
  import topTheme from "./top-theme";
  import {resolveUrlPath} from "@/util/util";
  import {getSysVerLog} from '@/api/log'

  export default {
    components: {topLock, topMenu, topTheme},
    name: "top",
    data() {
      return {
        tableData: [],
        spanData: [],
        sysVer: '',
        verDetailVisible: false
      };
    },
    filters: {},
    created() {
      this.getSysVerLog();
    },
    mounted() {
      listenfullscreen(this.setScreen);
    },
    computed: {
      ...mapState({
        userInfo: state => state.user.userInfo
      }),
      ...mapGetters(["menu", "isFullScren", "isCollapse"])
    },
    methods: {
      getSysVerLog() {
        getSysVerLog().then(response => {
          this.tableData = response.data
          if (this.tableData.length != 0) {
            this.sysVer = this.tableData[0].version
          }
          this.getSpanData(this.tableData);
        })
      },
      getSpanData(data) {
        this.spanData = [];
        let pos = 0;
        let pos1 = 0;
        this.tableData.forEach((item, index) => {
          if (index === 0) {
            this.spanData.push(1);
            pos = 0;
          } else {
            if (item.version === this.tableData[index - 1].version) {
              this.spanData[pos] += 1;
              this.spanData.push(0);
            } else {
              this.spanData.push(1);
              pos = index;
            }
          }
        });
      },
      objectSpanMethod({row, column, rowIndex, columnIndex}) {
        if (columnIndex === 0 || columnIndex === 1) {
          const _row = this.spanData[rowIndex]
          const _col = _row > 0 ? 1 : 0;
          return {
            rowspan: _row,
            colspan: _col
          }
        }
      },
      showVerDetail() {
        this.verDetailVisible = true
      },
      showCollapse() {
        this.$store.commit("SET_COLLAPSE");
      },
      handleScreen() {
        fullscreenToggel();
      },
      setScreen() {
        this.$store.commit("SET_FULLSCREN");
      },
      toPersonal() {
        this.getPersonal(this.menu);
      },
      downUm(){
        window.open('../static/um.pdf')
      },
      getPersonal(arr) {
        for (var i = 0; i < arr.length; i++) {
          if (arr[i].name == '个人中心') {
            this.$router.push({
              path: resolveUrlPath(arr[i].path, arr[i].label),
              query: arr[i].query
            });
          } else {
            if (arr[i].children.length > 0) {
              this.getPersonal(arr[i].children);
            }
          }
        }
      },
      logout() {
        this.$confirm("是否退出系统, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(() => {
          this.$store.dispatch("LogOut").then(() => {
            this.$router.push({path: "/login"});
          });
        });
      }
    }
  };
</script>

<style lang="scss" scoped>
  .el-dropdown-menu .el-dropdown-menu__item a {
    display: block;
  }
</style>




// WEBPACK FOOTER //
// index.vue?098b0bfa